import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import axios from "../API/axios";
import AuthContext from "../Context/AuthProvider";
import { showLoadingImage } from "../Utility/Utility";
import { changeAppointment, getAvailableSlots } from "../API/AppointmentsApi";
import { getClinicalServices, getPrimaryClinicalServices } from "../API/FacilitySettingsApi";
import { Modal, Toast } from "bootstrap";
import {
  addDays,
  getDateOnlyAsString,
  getDatesArray,
} from "../Utility/DateTimeUtility";
import AvailableSlots from "./AvailableSlots";

function ChangeAppointment({ reset, appointment, refreshAppointments }) {
  const errRef = useRef();
  const [errorMessage, setErrorMessage] = useState();
  const [availablePhysicians, setAvailablePhysicians] = useState();
  const USER_SEARCH_URL = "/api/account/search";
  const [availableSlots, setAvailableSlots] = useState();
  const { auth } = useContext(AuthContext);
  const [patientNotes, setPatientNotes] = useState(appointment?.notes);
  const location = useLocation();
  const navigate = useNavigate();
  const [availableServices, setAvailableServices] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [prevSelectedTimeSlot, setPrevSelectedTimeSlot] = useState();
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState(
    appointment?.clinicalService?.id
  );
  const [selectedPhysicianId, setSelectedPhysicianId] = useState(
    appointment?.physician?.id
  );
  const errorToast = new Toast(document.getElementById("errorToast"));
  const successToast = new Toast(document.getElementById("successToast"));
  const noOfDaysToShowSlots = 7;
  const [dateRange, setDateRange] = useState(
    getDatesArray(new Date(), noOfDaysToShowSlots)
  );
  const [disablePreviousButton, setDisablePreviousButton] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [addingAppointment, setAddingAppointment] = useState(false);

  useEffect(() => {
    const loadInfoToBeEdited = async () => {
    setSelectedServiceId(appointment?.clinicalService?.id);
    setSelectedPhysicianId(appointment?.physician?.id);
    setPatientNotes(appointment?.notes);
    setPrevSelectedTimeSlot(appointment?.appointmentDateTime);
    var result = await getAvailableSlots(dateRange, auth, appointment?.physician?.id, appointment?.clinicalService?.id);
    if (result?.isSuccess) {
      setAvailableSlots(result?.data);
    }  
    // else {
    //   setAvailableSlots(undefined);
    //   setErrorMessage(result?.data);
    //   //errorToast.show();
    // } 
  }
    loadInfoToBeEdited();
  }, [appointment, auth, dateRange]);

  useEffect(() => {
    const getPhysicians = async () => {
      await axios
        .post(
          USER_SEARCH_URL,
          {
            facilityId: auth.selectedFacility.id,
            roles: ["Physician"],
          },
          {
            headers: {
              Authorization: "Bearer " + auth.authToken,
              Accept: "application/json, text/plain, */*",
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          setAvailablePhysicians(response?.data);
          // if (response?.data?.length > 0) {
          //   //setPhysicianId(response?.data[0].id);
          // }
        })
        .catch(function (error) {
          setErrorMessage(error?.response?.data);
        });
    };

    const setClinicalServices = async () => {
      var result = await getPrimaryClinicalServices(auth);
      if (result.isSuccess) {
        console.log(result?.data);
        setAvailableServices(result?.data);
      } else {
        setErrorMessage(result.data);
      }
    };
    setClinicalServices();
    getPhysicians();
  }, [auth]);


  const showSlotsForDefaultDateRange = () => {
    refreshSlots(dateRange);
  };

  const refreshSlots = async (range) => {
    setShowSpinner(true);
    // const dates = getDatesArray(new Date(), 7);
    // setDateRange(dates);
    const serviceId = document.querySelector("#serviceSelector").value;
    const physicianId = document.querySelector("#physicianSelector").value;
    var result = {};
    result = await getAvailableSlots(range, auth, physicianId, serviceId);
    setSelectedServiceId(serviceId);
    setSelectedPhysicianId(physicianId);
    if (serviceId !== "" && physicianId !== "") {
      if (result?.isSuccess) {
        setAvailableSlots(result?.data);
      } else {
        setAvailableSlots(undefined);
        setErrorMessage(result?.data);
        //errorToast.show();
      }
    } else {
      setSelectedTimeSlot(undefined);
    }
    setShowSpinner(false);
  };

  const saveAppointment = async (e) => {
    // setAddingAppointment(true);
    // e.preventDefault();
    // const physicianId = document.querySelector("#physicianSelector").value;
    // const serviceId = document.querySelector("#serviceSelector").value;
    // const result = await changeAppointment(
    //   auth,
    //   appointment?.id,
    //   selectedTimeSlot,
    //   physicianId,
    //   patientNotes,
    //   serviceId
    // );
    // if (result.isSuccess) {
    //   const modal = Modal.getOrCreateInstance("#changeAppointmentModal");
    //   modal.hide();
    //   refreshAppointments();
    //   //setSuccessMessage("Appointment updated successfully.");
    //   //successToast.show();
    //   //showAppointments();
    // } else {
    //   setErrorMessage("Error occurred while updating the appointment.");
    //   errorToast.show();
    // }
    // setAddingAppointment(false);
  };

  const onCancel = () => {
    reset();
  };

  const onNextDateRangeClick = () => {
    const lastDateInPreviousSelection = dateRange[dateRange.length - 1];
    const firstDayInNextDateRange = addDays(lastDateInPreviousSelection, 1);
    const newDateRange = getDatesArray(
      firstDayInNextDateRange,
      noOfDaysToShowSlots
    );
    setDateRange(newDateRange);
    refreshSlots(newDateRange);
    setDisablePreviousButton(false);
  };

  const onPreviousDateRangeClick = () => {
    const firstDateInPreviousSelection = dateRange[0];

    const firstDayInNextDateRange = addDays(
      firstDateInPreviousSelection,
      0 - noOfDaysToShowSlots
    );
    const newDateRange = getDatesArray(
      firstDayInNextDateRange,
      noOfDaysToShowSlots
    );
    console.log(newDateRange[0]);
    console.log(getDateOnlyAsString(new Date()));

    setDateRange(newDateRange);
    refreshSlots(newDateRange);
    if (newDateRange[0] === getDateOnlyAsString(new Date())) {
      setDisablePreviousButton(true);
    } else {
      setDisablePreviousButton(false);
    }
  };

  return (
    <div
      class="modal"
      tabindex="-1"
      id="changeAppointmentModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        style={{ minWidth: "60%" }}
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Edit Appointment Details for {appointment?.patient?.prefix}{" "}
              {appointment?.patient?.firstName} {appointment?.patient?.lastName}
            </h5>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row mt-1">
                <div class="col-6 justify-content-start">
                  <div class="row justify-content-center align-items-center mb-3 g-0">
                    <div class="col-12">
                      <label>Service</label>

                      <div class="">
                        <select
                          class="form-select"
                          name=""
                          id="serviceSelector"
                          disabled={addingAppointment}
                          value={selectedServiceId}
                          onChange={(e) => {
                            setSelectedServiceId(e.target.value);
                            showSlotsForDefaultDateRange();
                          }}
                        >
                          {availableServices &&
                            availableServices?.map((s) => (
                              <option value={s.id}>{s.name}</option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-center align-items-center mb-3">
                    <div class="col-12">
                      <lable>With</lable>

                      <div class="">
                        <select
                          class="form-select form-select"
                          name=""
                          id="physicianSelector"
                          disabled={addingAppointment}
                          //onChange={(e) => setPhysicianId(e.target.value)}
                          value={selectedPhysicianId}
                          onChange={(e) => {
                            setSelectedPhysicianId(e.target.value);
                            showSlotsForDefaultDateRange();
                          }}
                        >
                          <option value="">Select physician</option>
                          {availablePhysicians &&
                            availablePhysicians?.map((p) => (
                              <option value={p.id}>
                                {p.salutation} {p.firstName} {p.lastName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-center align-items-center">
                    <div class="col-12">
                      <label>Patient Notes</label>

                      <div class="mb-3">
                        <textarea
                          class="span6 w-100 d-flex rounded"
                          rows="3"
                          placeholder="Write about the complaint or purpose of the patient's visit."
                          value={patientNotes || ""}
                          disabled={addingAppointment}
                          onChange={(e) => setPatientNotes(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-center align-items-center">
                    <div class="col-12">
                      <label>Previously Time Slot</label>

                      <div class="mb-3">
                        <label>
                          {new Date(prevSelectedTimeSlot).toLocaleString(
                            "en-US",
                            {
                              weekday: "short",
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 justify-content-start">
                  <div
                    class="row g-0 justify-content-center border rounded-3"
                    style={{ height: 300 }}
                  >
                    <div
                      class="row justify-content-start align-items-center pb-1 g-0 pt-1 "
                      style={{ height: 35 }}
                    >
                      <div class="col-2 d-flex justify-content-start">
                        <button
                          class=" btn btn-primary border rounded-5 btn-sm ms-1"
                          onClick={onPreviousDateRangeClick}
                          disabled={
                            selectedPhysicianId === "" ||
                            selectedServiceId === "" ||
                            disablePreviousButton
                          }
                        >
                          <i class="bi bi-caret-left-fill"></i>
                        </button>
                      </div>
                      <div class="col-8 d-flex justify-content-center">
                        <label class="fw-bold">Available Slots</label>
                      </div>
                      <div class="col-2 d-flex justify-content-end">
                        <button
                          class=" btn btn-primary border rounded-5 btn-sm me-1"
                          onClick={onNextDateRangeClick}
                          disabled={
                            selectedPhysicianId === "" ||
                            selectedServiceId === ""
                          }
                        >
                          <i class="bi bi-caret-right-fill"></i>
                        </button>
                      </div>
                    </div>
                    <div
                      class="row d-flex align-items-center justify-content-start g-0"
                      style={{ height: 225, overflow: "scroll" }}
                    >
                      {showSpinner ? (
                        showLoadingImage()
                      ) : (
                        <div class="col-12 g-0 d-flex justify-content-center pb-2">
                          {selectedPhysicianId !== "" &&
                          selectedServiceId !== "" ? (
                            <AvailableSlots
                              dateTimeSlots={availableSlots}
                              setTimeSlot={setSelectedTimeSlot}
                            ></AvailableSlots>
                          ) : (
                            <label
                              className="ms-1 
                fst-italic"
                            >
                              Select a service and a physician to view the
                              available slots.
                            </label>
                          )}
                        </div>
                      )}
                    </div>
                    <div
                      class="row justify-content-start align-items-center border-top g-0"
                      style={{ height: 40 }}
                    >
                      <div class="col-12 d-flex justify-content-start">
                        <label class="ms-1 fw-bold">Selected Slot:</label>
                        {selectedTimeSlot ? (
                          <label class="fw-bold ms-2">
                            {new Date(selectedTimeSlot).toLocaleString(
                              "en-US",
                              {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </label>
                        ) : (
                          <label class="fst-italic ms-2">
                            No slot selected
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              onClick={saveAppointment}
              disabled={addingAppointment || !selectedTimeSlot}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ChangeAppointment;
